import { IContributorRating } from 'src/types/contributors';

export const RATINGS: IContributorRating[] = [
    {
        label: 'Python',
        value: 2.5,
        count: 22
    },
    {
        label: 'React',
        value: 2.5,
        count: 22
    },
    {
        label: 'Django',
        value: 2.5,
        count: 22
    },
    {
        label: 'QA',
        value: 2.5,
        count: 22
    },
    {
        label: 'Quality',
        value: 2.5,
        count: 22
    }
];
